import styled from "styled-components";
import { GrayColors } from "@smartsuite/types";

export const CheckListItemWrapper = styled.div`
  overflow: hidden;
  width: 100%;
  padding: 10px 13px 28px 13px;
  background: ${GrayColors["G-0"]};
  border: 1px solid ${GrayColors["G-2"]};
  border-radius: 6px;
  .pill-picker-editor__plus-button {
    display: none;
  }
  .is-default .empty-node {
    visibility: visible;
  }
`;

export const CheckListItemTop = styled.div``;

export const CheckListItemBottom = styled.div`
  display: flex;
  margin-top: 20px;
`;

export const CheckListItemFieldWrapper = styled.div`
  width: 50%;
  &:nth-child(even) {
    padding-left: 11px;
  }
  &:nth-child(odd) {
    padding-right: 11px;
  }
`;
